import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-db-dark text-white py-12 border-t-2 border-db-red">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div data-aos="fade-up" data-aos-delay="0">
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="/logo.png"
                alt="Digital Barcode Logo"
                className="h-20 w-auto"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            </div>
            <p className="text-gray-400 text-sm mb-4">Leading provider of barcode solutions, industrial printing, and scanning technology for businesses worldwide.</p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-db-red transition transform hover:scale-110"><i className="fab fa-linkedin text-xl"></i></a>
              <a href="#" className="text-gray-400 hover:text-db-red transition transform hover:scale-110"><i className="fab fa-twitter text-xl"></i></a>
              <a href="#" className="text-gray-400 hover:text-db-red transition transform hover:scale-110"><i className="fab fa-facebook text-xl"></i></a>
              <a href="#" className="text-gray-400 hover:text-db-red transition transform hover:scale-110"><i className="fab fa-instagram text-xl"></i></a>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="100">
            <h4 className="font-bold mb-4">Products</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/categories" className="hover:text-db-red transition hover:pl-2 inline-block">All Categories</Link></li>
              <li><Link to="/products" className="hover:text-db-red transition hover:pl-2 inline-block">Barcode Printers</Link></li>
              <li><Link to="/products" className="hover:text-db-red transition hover:pl-2 inline-block">Barcode Scanners</Link></li>
              <li><Link to="/products" className="hover:text-db-red transition hover:pl-2 inline-block">Labels & Ribbons</Link></li>
              <li><Link to="/products" className="hover:text-db-red transition hover:pl-2 inline-block">Thermal Printers</Link></li>
            </ul>
          </div>
          <div data-aos="fade-up" data-aos-delay="200">
            <h4 className="font-bold mb-4">Solutions</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-db-red transition hover:pl-2 inline-block">Inventory Management</a></li>
              <li><a href="#" className="hover:text-db-red transition hover:pl-2 inline-block">Retail Labelling</a></li>
              <li><a href="#" className="hover:text-db-red transition hover:pl-2 inline-block">Asset Tracking</a></li>
              <li><a href="#" className="hover:text-db-red transition hover:pl-2 inline-block">Warehouse Solutions</a></li>
            </ul>
          </div>
          <div data-aos="fade-up" data-aos-delay="300">
            <h4 className="font-bold mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/about" className="hover:text-db-red transition hover:pl-2 inline-block">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-db-red transition hover:pl-2 inline-block">Contact Us</Link></li>
              <li><a href="#" className="hover:text-db-red transition hover:pl-2 inline-block">Certificates</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-8 text-center text-sm text-gray-400">
          <p>© 2026 Digital Barcode. All rights reserved. | <a href="#" className="hover:text-db-red transition">Privacy Policy</a> | <a href="#" className="hover:text-db-red transition">Terms of Service</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

